// Imports: local files.
import ApiClient from '../../services/ApiClient';
import { showSnackbar, dispatchLoading, dispatchSuccess, dispatchError, getAxiosError } from '../../utils/redux';

// Name of property to be used in reducer data.
const usersName = 'users';
const userName = 'user';

// Action Types: Get All Users.
export const GET_USERS_START = 'GET_USERS_START';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';
export const GET_USERS_RESET = 'GET_USERS_RESET';

// Action Types: Get One User.
export const GET_USER_START = 'GET_USER_START';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILED = 'GET_USER_FAILED';
export const GET_USER_RESET = 'GET_USER_RESET';

// Action Types: Block User.
export const BLOCK_USER_START = 'BLOCK_USER_START';
export const BLOCK_USER_SUCCESS = 'BLOCK_USER_SUCCESS';
export const BLOCK_USER_FAILED = 'BLOCK_USER_FAILED';
export const BLOCK_USER_RESET = 'BLOCK_USER_RESET';

export const getUserStats = () => async (dispatch) => {
    try {
        dispatch({ type: 'GET_USER_STATS_REQUEST' });
        const response = await ApiClient.get('/users/stats');
        dispatch({ 
            type: 'GET_USER_STATS_SUCCESS', 
            payload: response.data 
        });
    } catch (error) {
        dispatch({ type: 'GET_USER_STATS_FAIL', payload: error.message });
    }
};
// Action Creators: Get All Users.
const getUsersStart = (payload) => ({ type: GET_USERS_START, payload });
const getUsersSuccess = (payload) => ({ type: GET_USERS_SUCCESS, payload });
const getUsersFailed = (payload) => ({ type: GET_USERS_FAILED, payload });
const getUsersReset = () => ({ type: GET_USERS_RESET });

// Action Creators: Get One User.
const getUserStart = (payload) => ({ type: GET_USER_START, payload });
const getUserSuccess = (payload) => ({ type: GET_USER_SUCCESS, payload });
const getUserFailed = (payload) => ({ type: GET_USER_FAILED, payload });
const getUserReset = () => ({ type: GET_USER_RESET });

// Action Creators: Block User.
const blockUserStart = (payload) => ({ type: BLOCK_USER_START, payload });
const blockUserSuccess = (payload) => ({ type: BLOCK_USER_SUCCESS, payload });
const blockUserFailed = (payload) => ({ type: BLOCK_USER_FAILED, payload });
const blockUserReset = () => ({ type: BLOCK_USER_RESET });

// Actions: Get All Users.
export const getUsers = (payload, options = {}) => {
  const { page, limit, pagination, blocked, name } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getUsersStart);

      const query = { page, limit, name, pagination, ...(blocked === 2 ? {} : { blocked }) };

      const result = await ApiClient.get('/users', { params: query });
      if (result.data?.success) {
        const { users } = result.data?.data;
        dispatchSuccess(dispatch, getUsersSuccess, users, usersName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getUsersFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getUsersFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get All Users.
export const clearUsers = () => getUsersReset();

// Actions: Get One User.
export const getUser = (payload, options = {}) => {
  const { userId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getUserStart);

      const result = await ApiClient.get(`/users/${userId}`);
      if (result.data?.success) {
        const { user } = result.data?.data;
        dispatchSuccess(dispatch, getUserSuccess, user, userName);
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getUserFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getUserFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Get One User.
export const clearUser = () => getUserReset();

// Actions: Block User.
export const blockUser = (payload, options = {}) => {
  const { userId } = payload;
  const {} = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, blockUserStart);

      const {} = payload;

      const result = await ApiClient.put(`/users/${userId}/block`, {});
      if (result.data?.success) {
        const { blocked } = result.data?.data;
        dispatchSuccess(dispatch, blockUserSuccess, blocked, userName);
        showSnackbar(dispatch, `User ${blocked ? 'blocked' : 'unblocked'} successfully!`, 'success');
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, blockUserFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, blockUserFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Blocked User.
export const clearBlockedUser = () => blockUserReset();
